/*
 * @Autor: Nehc
 * @Date: 2020-11-26 19:28:02
 * @LastEditors: Nehc
 * @LastEditTime: 2020-11-27 09:43:18
 */
import Rules from './rule.vue';

export default Rules;
